import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import Lead from "./Lead";
const initialFieldValues = {
    landingPageId: "00000000-0000-0000-0000-000000000000",
    phoneNumber: "",
    email: "",
    heroSectionTitle_1: "",
    heroSectionTitle_2: "",
    heroSectionTitle_3: "",
    heroSectionParagraph: "",
    aboutus_Title: "",
    aboutus_List: "",
    about_Image: "",
    broker_Title: "",
    broker_List: "",
    broker_Image: "",
    funder_Title: "",
    funder_List: "",
    funder_Image: "",
    comingSoon_Text: "",
    signUp_Text: "",
    footer_Address: "",
    footer_CopyRights: "",
    topHeader_Color: "",
    heroSection_Color: "",
    footer_Color: "",
    footer_Facebook: "",
    footer_Instagram: "",
    footer_LinkedIn: "",
    footer_Twitter: "",
};
export default function HomePage() {
    const [values, setValues] = useState(initialFieldValues);
    const [aboutListItems, setAboutListItems] = useState([]);
    const [funderListItems, setFunderListItems] = useState([]);
    const [brokerListItems, setBrokerListItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetData = () => {
        axios.get(config.APIACTIVATEURL + config.LANDINGPAGEGET, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setValues(response.data.data);
                    if (response.data.data != null) {
                        if (response.data.data.aboutus_List != null) {
                            setAboutListItems(response.data.data.aboutus_List.split('*').filter(Boolean))
                        }
                        if (response.data.data.funder_List != null) {
                            setFunderListItems(response.data.data.funder_List.split('*').filter(Boolean))
                        }
                        if (response.data.data.broker_List != null) {
                            setBrokerListItems(response.data.data.broker_List.split('*').filter(Boolean))
                        }
                        setLoading(false);
                    }
                }
            })
            .catch((error) => {
                //setError('Failed to fetch data');
                console.error(error);
            });
    };
    const [canAutoplay, setCanAutoplay] = useState(false);

  useEffect(() => {
    // Example logic to conditionally enable autoplay (e.g., based on screen width or user action)
    const screenWidth = window.innerWidth;
    if (screenWidth > 768) {
      setCanAutoplay(true); // Autoplay on desktop
    }
  }, []);
    useEffect(() => {
        setLoading(true);
        GetData();
    }, [])
    return (
        <>
            {loading === true ?
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <img src="../assets/images/logo3d.png" width="350px" height="100px" alt="Logo" />
                    <p className="form-label" style={{ marginTop: '10px' }}>Loading...</p>
                </div>
                :
                <div className="layout-wrapper">
                    <div className="topbar-image py-8 rounded-0 mb-0 alert fade show" style={{ backgroundColor: values.topHeader_Color }}>
                        <div className="d-flex justify-content-end gap-sm-3 gap-2 align-items-right text-right flex-md-nowrap flex-wrap">
                            <span className="mb-0 text-white fw-bold px-2"><i className="ri-phone-line me-2" style={{ color: "#d60000" }}></i>{values.phoneNumber}</span>
                            <p className="mb-0 text-white fw-bold"><i className="ri-mail-line me-2" style={{ color: "#d60000" }}></i>{values.email}</p>
                        </div>
                    </div>
                    <div className="landing" style={{ paddingTop: "0px", marginTop: "0px", backgroundColor: values.heroSection_Color }}>
                        <nav className="navbar navbar-expand-lg navbar-landing navbar-light fixed-top">
                            <div className="container">
                                <Link to={"/"} className="navbar-brand">
                                    <img src="/assets/images/logo3d.png" className="card-logo card-logo-dark" alt="logo dark" height={80} width={250} />
                                    <img src="/assets/images/logo3d.png" className="card-logo card-logo-light" alt="logo light" height={80} width={250} />
                                </Link>
                                <div className="collapse navbar-collapse d-flex justify-content-end">
                                    <div className="me-2">
                                        <Link to={"/login"} className="btn text-white me-2" style={{ backgroundColor: "#d60000" }}>Login</Link>
                                    </div>
                                    <div className>
                                        <Link to={"/register"} className="btn text-white me-2" style={{ backgroundColor: "#d60000" }}>Register</Link>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <div className="nft-hero" style={{ backgroundColor: values.heroSection_Color }}>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="text-center">
                                            <h3 className="outfitslider mb-4 lh-base text-black">{values.heroSectionTitle_1}<br />
                                                <span className="text-black">{values.heroSectionTitle_2}</span></h3>
                                        </div>
                                        <div className="text-center">
                                            <h3 className="outfit mb-4 lh-base" style={{ color: "#00000" }}>{values.heroSectionTitle_3}</h3>
                                            <p className="fs-4 mb-4" style={{ color: "#000000" }}>
                                                {values.heroSectionParagraph}
                                            </p>
                                        </div>
                                    </div>{/*end col*/}
                                </div>{/* end row */}
                            </div>
                        </div>
                    </div>
                    <section className="pt-3 body-wrapper" style={{ marginTop: "0px", paddingTop: "0px", backgroundColor: "#f1f2f3" }}>
                        <div className="container-fluid">
                            <div className="row justify-content-between">
                                <div className="col-4">
                                    <div>
                                        <img src={values.aboutImageSrc} alt="icon" class="w-100 h-100 rounded-3"></img>
                                    </div>
                                </div>
                                <div className="col-8">
                                    <h2 className="fw-bolder mb-4">{values.aboutus_Title}</h2>
                                    <div className="row">
                                        <div className="col-12 mb-lg-5">
                                            {aboutListItems.map((item, idx) => (
                                                <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                                    <div className="d-flex align-items-center">
                                                        <iconify-icon className="text-danger me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                        {item}
                                                    </div>
                                                </li>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="p-0 text-center">
                        <h3>A Better Way to Work for Brokers and Funders</h3>
                    </div>
                    <section className="pt-0 body-wrapper" style={{ marginTop: "0px" }}>
                        <div className="container-fluid">
                            <div className="row justify-content-between">
                                <div className="col-6">
                                    <h2 className="fw-bolder mb-4">{values.broker_Title}</h2>
                                    <div className="row">
                                        <div className="col-12 mb-lg-5">
                                            <ul class="list-group outfit" style={{ border: "0" }}>
                                                {brokerListItems.map((item, idx) => (
                                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                                        <div className="d-flex align-items-center">
                                                            <iconify-icon className="text-danger me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                            {item}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div>
                                        <img src={values.brokerImageSrc} alt="icon" className="w-100 rounded-3" style={{ maxHeight: "400px", maxWidth: "500px" }}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-black py-3 ">
                        <div className="container-fluid">
                            <div className="d-flex align-items-center justify-content-center flex-md-nowrap flex-wrap gap-3">
                                <p className="mb-0 text-white fs-4">Launching soon!</p>
                                <Link to="https://cal.com/dooley/demo" target="_blank" className="text-white fs-4 fw-semibold text-underline">Schedule Live Demo </Link>
                            </div>
                        </div>
                    </section>
                    <section className="video-wrapper">
                        <div className="container-fluid">
                            <video
                                src="/assets/ProductDemo.mp4"  // If in public folder
                                autoPlay
                                loop
                                muted
                                controls  // Remove this line if you don’t want video controls
                                style={{ width: '100%', height: '50%' }}
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </section>
                    <section className="pt-3 body-wrapper">
                        <div className="container-fluid">
                            <div className="row justify-content-between">
                                <div className="col-6">
                                    <h2 className="fw-bolder mb-4">{values.funder_Title}</h2>
                                    <div className="row">
                                        <div className="col-12 mb-lg-5">
                                            <ul class="list-group outfit" style={{ border: "0" }}>
                                                {funderListItems.map((item, idx) => (
                                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center text-black p-3 fs-4" style={{ border: "0" }}>
                                                        <div className="d-flex align-items-center">
                                                            <iconify-icon className="text-danger me-2" icon="material-symbols:thumb-up-outline" width="24" height="24"></iconify-icon>
                                                            {item}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="col-12 mb-lg-5 text-center">
                                            <Link to={"https://www.jotform.com/build/250136607797060"} target="_blank" className="btn btn-danger text-black" style={{ backgroundColor: "#d60000", border: "2px black solid" }}><b>Get High-Quality Submissions <br></br>Join Our Funder Matrix</b></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div>
                                        <img src={values.funderImageSrc} alt="icon" className="w-100 rounded-3" style={{ maxHeight: "400px", maxWidth: "500px" }}></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-black py-3 ">
                        <div className="container-fluid">
                            <div className="d-flex align-items-center justify-content-center flex-md-nowrap flex-wrap gap-3">
                                <p className="mb-0 text-white fs-4">Be the first to experience the future of MCA deal management.</p>
                                <p className="mb-0 text-white fs-6">Sign up to receive updates</p>
                            </div>
                        </div>
                    </section>
                    <section className="py-lg-12 py-7" style={{ backgroundColor: "#c1c2c3" }}>
                        <div className="container-fluid">
                            <div className="row gx-lg-7 gy-lg-0 gy-7">
                                <div className="col-lg-12">
                                    <div className="rounded-4 position-relative" style={{ backgroundColor: "#f1f2f3" }}>
                                        <Lead email={values.email} phoneNumber={values.phoneNumber}></Lead>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="custom-footer py-5 position-relative" style={{ backgroundColor: values.footer_Color }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 mt-4"><div>
                                    <div>
                                        <img alt="logo light" height={80} width={280} src="/assets/images/logo3d.png" />
                                    </div>
                                    <div className="mt-4 text-black">
                                        <p>{values.footer_CopyRights}</p>
                                    </div>
                                </div>
                                </div>
                                <div className="col-lg-7 ms-lg-auto">
                                    <div className="row">
                                        <div className="col-sm-4 mt-4" />
                                        <div className="col-sm-3 mt-4" />
                                        <div className="col-sm-5 mt-4">
                                            <h5 className="text-black mb-0">Contact</h5>
                                            <div className="text-black mt-3">
                                                <ul className="list-unstyled ff-secondary footer-list fs-3">
                                                    {values.footer_Address==="null"?"":<li className="p-1">{values.footer_Address}</li>}
                                                    <li className="p-1">Email : {values.email}</li>
                                                    <li className="p-1">Phone : {values.phoneNumber}</li>
                                                </ul>
                                            </div>
                                            <div className="text-sm-end mt-3 mt-sm-0">
                                                <ul className="list-inline mb-0 footer-social-link">
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Facebook} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-facebook-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Twitter} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-twitter-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_LinkedIn} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-linkedin-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <Link className="avatar-xs d-block" style={{ backgroundColor: "#D60000" }} to={values.footer_Instagram} target="_blank">
                                                            <div className="avatar-title text-white"><i className="ri-instagram-fill" />
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            }
        </>
    );
}